"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const constants_1 = require("../../../constants/constants");
const eventConstants_1 = require("../../../constants/eventConstants");
const typesConstants_1 = require("../../../constants/typesConstants");
const actionsSlice_1 = require("../../../features/actions/actionsSlice");
const useAppDispatch_1 = __importDefault(require("../../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../../hooks/useAppSelector"));
const useWebDesktopDesign_1 = __importDefault(require("../../../hooks/useWebDesktopDesign"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const themes_1 = __importDefault(require("../../../styles/themes"));
const actionsLoadingComponent_1 = __importDefault(require("../../actionsLoadingComponent/actionsLoadingComponent"));
const boxTitle_1 = __importDefault(require("../../boxTitle/boxTitle"));
const button_1 = __importDefault(require("../../button/button"));
const radioInput_1 = __importDefault(require("../../radioInput/radioInput"));
const goBackComponent_1 = __importDefault(require("../baseContent/goBackComponent"));
const sendSMSConstants_1 = require("./sendSMSConstants");
const defaultProps = {
    showTitle: true,
    withMinHeight: true,
};
const SendSMS = ({ selectedContact, setBaseContent, scheduleId, showTitle, withMinHeight, }) => {
    const dispatch = useAppDispatch_1.default();
    const [smsContent, setSmsContent] = react_1.useState(null);
    const [customSMSValue, setCustomSMSValue] = react_1.useState('');
    const [sendSMSError, setSendSMSError] = react_1.useState('');
    const { smsStatus, officerType } = useAppSelector_1.default((state) => ({
        smsStatus: state.actions.sendSMS.status,
        officerType: state.auth.user.officer_type,
    }));
    const smsChoices = [...selectedContact.available_sms, sendSMSConstants_1.SEND_CUSTOM_SMS].map((el) => ({
        value: el,
        label: el,
    }));
    const contentIsSendCustomSMSChoice = smsContent === sendSMSConstants_1.SEND_CUSTOM_SMS;
    const isCustomerSupport = officerType === typesConstants_1.OFFICER_TYPES_CUSTOMER_SUPPORT;
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT_1);
    const buttonContainerStyles = isDesktop ? [styles_1.default.flexDirectionRow] : [];
    const saveAndClose = () => {
        if (!smsContent || (contentIsSendCustomSMSChoice && customSMSValue === '')) {
            // prevent sending sms without picking a choice.
            setSendSMSError(sendSMSConstants_1.EMPTY_SMS_CONTENT_ERROR_MSG);
            return;
        }
        const payload = {
            scheduleId,
            content: contentIsSendCustomSMSChoice ? customSMSValue : smsContent,
            recipient_phone_number: selectedContact.phone_number,
        };
        setSendSMSError('');
        dispatch(actionsSlice_1.sendSMS(payload)).then((result) => {
            if (result.meta.requestStatus === constants_1.FULFILLED_RESPONSE_CONSTANT) {
                setSmsContent(null);
                setCustomSMSValue('');
                if (setBaseContent) {
                    setBaseContent();
                }
            }
        });
    };
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(actionsSlice_1.resetSendSMSState());
    }, []));
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, withMinHeight && styles_1.default.minHeight] },
        showTitle && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexFour] },
                react_1.default.createElement(boxTitle_1.default, { title: `${selectedContact.first_name} ${selectedContact.last_name}` })))),
        smsStatus === typesConstants_1.SUCCEEDED_STATUS && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.alignCenterCenter] },
            react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textTitle, { color: colors_1.default.BLUE, fontWeight: 'bold' }] }, `The SMS to ${selectedContact.first_name} was successfully sent...`))),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.alignCenterCenter] },
            react_1.default.createElement(boxTitle_1.default, { title: "Pick an SMS" })),
        !!sendSMSError && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.alignCenterCenter] },
            react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textTitle, styles_1.default.textColorRed] }, sendSMSError))),
        react_1.default.createElement(actionsLoadingComponent_1.default, { actionType: typesConstants_1.SMS_ACTION_TYPE },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(radioInput_1.default, { choices: smsChoices, value: smsContent, setValue: setSmsContent }),
                contentIsSendCustomSMSChoice && (react_1.default.createElement(react_native_paper_1.TextInput, { label: "Your custom sms here", placeholder: "Your custom sms here", onChangeText: setCustomSMSValue, left: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput, value: customSMSValue })),
                react_1.default.createElement(react_native_1.View, { style: [buttonContainerStyles, styles_1.default.alignCenterCenter] },
                    setBaseContent && react_1.default.createElement(goBackComponent_1.default, { onPress: setBaseContent }),
                    react_1.default.createElement(button_1.default, { text: "Send & Close", icon: free_solid_svg_icons_1.faPlane, onPress: saveAndClose, fill: true, eventName: eventConstants_1.SEND_SMS_BUTTON_PRESS, disabled: isCustomerSupport }))))));
};
SendSMS.defaultProps = defaultProps;
exports.default = SendSMS;
